// Role page v2 content (wave 1). First GENERATED Sep 23 2026 by Maeve's gen_v2.py; since Oct 2026 edited in place
// (breadth pass Oct 23 2026: audience cards, 5th prompt, 3 FAQs). Keep FAQ = visible list (FAQPage JSON-LD).
/* eslint-disable */
const content = {
 "slug": "ai-sdr",
 "roleDisplay": "AI SDR",
 "phrase": "ai sdr",
 "seo": {
  "title": "AI SDR: An AI Sales Agent That Researches Leads | CellCog",
  "description": "An AI SDR that builds lead lists, researches each prospect, writes every email one to one, follows up on a set schedule and stops the moment they reply."
 },
 "painSub": "Cold outreach dies in the inbox because it reads like everyone else's template. Your AI SDR researches each prospect first, writes every email for one person, and stops the moment they reply.",
 "definition": "An AI SDR is an AI sales agent that builds lead lists from your ideal customer profile, researches each prospect, writes personal outreach and follows up on schedule. On CellCog an AI SDR is hired in minutes, sends from dedicated domains that protect your own, and researches every account with the agent ranked #1 on DeepResearch Bench (October 2026).",
 "panes": [
  {
   "num": "01 · LEADS",
   "title": "Builds the lead list.",
   "sub": "Companies and contacts that match your ideal customer, each with a reason it fits.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--table\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Lead list</span></div><div class=\"rf-body\"><div class=\"rf-head\"><b>Field-service leads</b><span>6 researched this morning</span></div><div class=\"rf-panel\"><table class=\"rf-table\"><thead><tr><th scope=\"col\">Company</th><th scope=\"col\">Contact</th><th scope=\"col\">Why now</th><th scope=\"col\">Status</th></tr></thead><tbody><tr><td data-label=\"Company\">Brightline HVAC</td><td data-label=\"Contact\">Dave Moreno<span class=\"rf-sub\">Owner</span></td><td data-label=\"Why now\">Hiring 4 technicians</td><td data-label=\"Status\"><span class=\"rf-chip rf-tone-blue\">Email drafted</span></td></tr><tr><td data-label=\"Company\">Canopy Pest Care</td><td data-label=\"Contact\">Jen Park<span class=\"rf-sub\">Operations lead</span></td><td data-label=\"Why now\">Opened a second branch</td><td data-label=\"Status\"><span class=\"rf-chip rf-tone-blue\">Email drafted</span></td></tr><tr><td data-label=\"Company\">Riverbend Plumbing</td><td data-label=\"Contact\">Sam Ito<span class=\"rf-sub\">General manager</span></td><td data-label=\"Why now\">Reviews mention missed visits</td><td data-label=\"Status\"><span class=\"rf-chip rf-tone-blue\">Email drafted</span></td></tr><tr><td data-label=\"Company\">Summit Solar Install</td><td data-label=\"Contact\">Ava Lind<span class=\"rf-sub\">COO</span></td><td data-label=\"Why now\">Expanding to two states</td><td data-label=\"Status\"><span class=\"rf-chip rf-tone-green\">Replied</span></td></tr><tr><td data-label=\"Company\">Harborview Electric</td><td data-label=\"Contact\">Ray Cole<span class=\"rf-sub\">Owner</span></td><td data-label=\"Why now\">Still booking by phone</td><td data-label=\"Status\"><span class=\"rf-chip rf-tone-graphite\">Researched</span></td></tr><tr><td data-label=\"Company\">Northgate Landscaping</td><td data-label=\"Contact\">Tia Ross<span class=\"rf-sub\">Office manager</span></td><td data-label=\"Why now\">Spring rush starts early</td><td data-label=\"Status\"><span class=\"rf-chip rf-tone-amber\">Your call</span></td></tr></tbody></table><ul class=\"rf-tlist\"><li class=\"rf-tl-item\"><div class=\"rf-tl-top\"><b>Brightline HVAC</b><span class=\"rf-chip rf-tone-blue\">Email drafted</span></div><span class=\"rf-tl-rest\">Dave Moreno · Hiring 4 technicians</span></li><li class=\"rf-tl-item\"><div class=\"rf-tl-top\"><b>Canopy Pest Care</b><span class=\"rf-chip rf-tone-blue\">Email drafted</span></div><span class=\"rf-tl-rest\">Jen Park · Opened a second branch</span></li><li class=\"rf-tl-item\"><div class=\"rf-tl-top\"><b>Riverbend Plumbing</b><span class=\"rf-chip rf-tone-blue\">Email drafted</span></div><span class=\"rf-tl-rest\">Sam Ito · Reviews mention missed visits</span></li><li class=\"rf-tl-item\"><div class=\"rf-tl-top\"><b>Summit Solar Install</b><span class=\"rf-chip rf-tone-green\">Replied</span></div><span class=\"rf-tl-rest\">Ava Lind · Expanding to two states</span></li></ul><div class=\"rf-tlist-more\"><p class=\"rf-sched-more\">and 2 more</p></div></div></div></div></div>"
  },
  {
   "num": "02 · EMAILS",
   "title": "Writes every email for one person.",
   "sub": "Researched first, then written to that prospect, not a template with a name swapped in.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--drafts\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Drafts</span></div><div class=\"rf-body\"><div class=\"rf-head\"><b>Personal emails</b><span>From your sending domain, waiting for your yes</span></div><div class=\"rf-drafts\"><div class=\"rf-draft\"><div class=\"rf-dr-h\"><span>Email</span><em>To: Jen Park</em></div><b class=\"rf-dr-s\">Your Eastgate branch</b><p>Hi Jen, congrats on opening Eastgate. With a second branch, dispatch is usually the first thing to strain. Worth 15 minutes to see one shared schedule?</p></div><div class=\"rf-draft\"><div class=\"rf-dr-h\"><span>Email</span><em>To: Dave Moreno</em></div><b class=\"rf-dr-s\">Four new technicians</b><p>Hi Dave, saw you are hiring four technicians before winter. Routing a bigger crew by phone gets hard fast. Open to a short call?</p></div><div class=\"rf-draft\"><div class=\"rf-dr-h\"><span>Email</span><em>To: Sam Ito</em></div><b class=\"rf-dr-s\">Missed visits in your reviews</b><p>Hi Sam, a few recent reviews mention visits that never happened. Automatic reminders help with that. Happy to show you how. Rowan, AI sales assistant at Quarrylane</p></div></div></div></div></div>"
  },
  {
   "num": "03 · MEMORY",
   "title": "Knows your pitch.",
   "sub": "Your offer, case studies and common objections live in your Drive, so every email tells the story the same way.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--drive\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Drive</span></div><div class=\"rf-body\"><div class=\"rf-drive\"><div class=\"rf-crumb\"><span>Drive</span><i aria-hidden=\"true\">/</i><span>Quarrylane</span><i aria-hidden=\"true\">/</i><b>Sales</b></div><ul class=\"rf-files\"><li class=\"rf-file\"><span class=\"rf-ficon rf-t-doc\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">Document</span></span><span class=\"rf-fname\">Ideal customer profile.docx</span><span class=\"rf-fmeta\">Field teams of 10 to 80</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-pdf\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">PDF file</span></span><span class=\"rf-fname\">Case study, Harbor HVAC.pdf</span><span class=\"rf-fmeta\">Fewer missed visits</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-xls\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M8 13h2\"/><path d=\"M14 13h2\"/><path d=\"M8 17h2\"/><path d=\"M14 17h2\"/></svg><span class=\"rf-sr\">Spreadsheet</span></span><span class=\"rf-fname\">Lead list, October.xlsx</span><span class=\"rf-fmeta\">120 researched</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-dir\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z\"/></svg><span class=\"rf-sr\">Folder</span></span><span class=\"rf-fname\">Objection notes</span><span class=\"rf-fmeta\">Added by you</span></li></ul><div class=\"rf-remember\"><b>Remembered</b><p>Lead with missed visits, never quote a price in a first email, and stop after 3 touches.</p></div></div></div></div></div>"
  },
  {
   "num": "04 · APPROVALS",
   "title": "Asks before the first send.",
   "sub": "New sequences wait for your yes. Approve, edit or skip each draft.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--approval\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Approvals</span></div><div class=\"rf-body\"><div class=\"rf-appr\"><div class=\"rf-appr-card\"><span class=\"rf-appr-h\"><i aria-hidden=\"true\"></i>Waiting for your yes</span><p class=\"rf-appr-q\">Send this reply to Ava Lind?</p><div class=\"rf-prev\"><div class=\"rf-prev-h\"><span>Email</span><em>To: Ava Lind</em></div><b class=\"rf-prev-t\">Re: Expanding to two states</b><p class=\"rf-prev-b\">Thanks Ava. Tuesday at 11:00 works. I will bring a short walkthrough of how teams in two states share one schedule.</p></div><div class=\"rf-appr-b\"><span class=\"rf-btn-y\">Approve</span><span class=\"rf-btn\">Edit</span><span class=\"rf-btn\">Skip</span></div></div><div class=\"rf-queue\"><span class=\"rf-queue-h\">2 more waiting</span><ul><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Follow-up to Ray Cole at Harborview</span><span class=\"rf-q-m\">Email · day 4</span></li><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Book the demo with Summit Solar</span><span class=\"rf-q-m\">Calendar · Tue 11:00</span></li></ul></div></div></div></div></div>"
  },
  {
   "num": "05 · REPORTS BACK",
   "title": "Reports on the pipeline.",
   "sub": "Who was contacted, who replied and which conversations are ready for you.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--report\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">End of day report</span></div><div class=\"rf-body\"><div class=\"rf-report\"><div class=\"rf-rep-h\"><b>Outbound today</b><span>Today, 5:45 pm</span></div><div class=\"rf-stats\"><div class=\"rf-stat\"><b>6</b><span>leads researched</span></div><div class=\"rf-stat\"><b>3</b><span>emails drafted</span></div><div class=\"rf-stat\"><b>1</b><span>reply</span></div></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--done\">Done</span><ul><li>Researched 6 field-service companies</li><li>Drafted 3 personal emails</li><li>Got a reply from Summit Solar</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--next\">Next</span><ul><li>Prepare the Summit Solar demo</li><li>Research 6 more HVAC teams</li><li>Send day-4 follow-ups</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--need\">Needs you</span><ul><li>Approve 3 emails before they go out</li></ul></div></div></div></div></div>"
  }
 ],
 "capabilities": [
  {
   "title": "Builds lead lists",
   "body": "Finds companies and contacts that match your ideal customer profile, with a reason each one fits."
  },
  {
   "title": "Researches every account",
   "body": "Reads the company and the person before a single word is written."
  },
  {
   "title": "Writes one-to-one emails",
   "body": "Each email is written for one prospect, grounded in that research."
  },
  {
   "title": "Follows up on a set schedule",
   "body": "Up to three touches per prospect, and your AI SDR stops the moment they reply."
  },
  {
   "title": "Hands off replies",
   "body": "Interested replies come to you with the thread and research attached."
  },
  {
   "title": "Reports on the pipeline",
   "body": "Contacted, replied and booked, with numbers you can check."
  }
 ],
 "steps": [
  {
   "n": "01",
   "title": "Hire in one line.",
   "body": "\"Hire an SDR. We sell payroll software to finance teams at 50 to 200 person companies.\""
  },
  {
   "n": "02",
   "title": "Connect your lead source.",
   "body": "Add Apollo or your CRM, or share a list. Cold email goes from dedicated sending domains, never your main inbox."
  },
  {
   "n": "03",
   "title": "Approve the first emails.",
   "body": "They send a small first batch of drafts. You approve, edit or skip each one."
  }
 ],
 "tools": [
  {
   "name": "Apollo",
   "logo": "https://logos.composio.dev/api/apollo"
  },
  {
   "name": "HubSpot",
   "logo": "https://logos.composio.dev/api/hubspot"
  },
  {
   "name": "Salesforce",
   "logo": "https://logos.composio.dev/api/salesforce"
  },
  {
   "name": "Attio",
   "logo": "https://logos.composio.dev/api/attio"
  },
  {
   "name": "Gmail",
   "logo": "https://logos.composio.dev/api/gmail"
  },
  {
   "name": "Google Sheets",
   "logo": "https://logos.composio.dev/api/googlesheets"
  },
  {
   "name": "Google Calendar",
   "logo": "https://logos.composio.dev/api/googlecalendar"
  },
  {
   "name": "Slack",
   "logo": "https://logos.composio.dev/api/slack"
  }
 ],
 "control": {
  "statement": "Nothing is sent without your yes.",
  "sub": "They do the research and the writing.",
  "accent": "You approve what goes out.",
  "rows": [
   {
    "title": "Drafts first",
    "body": "New sequences wait for your approval before the first send."
   },
   {
    "title": "Limits built in",
    "body": "Daily caps and one-to-one writing are part of the product, not a setting."
   },
   {
    "title": "Every thread visible",
    "body": "Each prospect, email and reply sits on one board you can read any time."
   }
  ]
 },
 "wont": {
  "sub": "They run your outbound.",
  "accent": "Some things stay off limits.",
  "rows": [
   {
    "title": "No cold calls",
    "body": "They email; they never cold call from their phone number."
   },
   {
    "title": "No blasts",
    "body": "Daily caps and one-to-one writing are built in, not optional."
   },
   {
    "title": "No cold email from your main domain",
    "body": "Cold email goes from separate sending domains, never your company inbox."
   }
  ]
 },
 "comparison": {
  "title": "Three ways to run outbound",
  "cols": [
   "Doing it yourself",
   "A sequencing tool",
   "AI SDR"
  ],
  "rows": [
   {
    "label": "Researches each prospect",
    "cells": [
     "If time allows",
     "No",
     "Yes, before writing"
    ]
   },
   {
    "label": "Writes each email",
    "cells": [
     "You",
     "Templates with fields",
     "One to one"
    ]
   },
   {
    "label": "Follows up",
    "cells": [
     "You remember",
     "On a timer",
     "On a set schedule"
    ]
   },
   {
    "label": "Stops when they reply",
    "cells": [
     "You",
     "Usually",
     "Right away"
    ]
   },
   {
    "label": "Protects your main domain",
    "cells": [
     "No",
     "Depends on setup",
     "Separate sending domains"
    ]
   },
   {
    "label": "Asks before sending",
    "cells": [
     "n/a",
     "No",
     "Yes, by default"
    ]
   }
  ]
 },
 "prompts": [
  {
   "q": "Here is our ideal customer profile: B2B SaaS, 11 to 50 people, US-based, selling to finance teams. Build a list of 25 target companies with the right contact at each and a one-line reason they fit.",
   "deliverable": "a researched lead list with fit notes"
  },
  {
   "q": "Research these 10 prospects and write a personalized opening email for each, referencing something real about their company. Keep each under 90 words.",
   "deliverable": "ten researched, individually written outreach drafts"
  },
  {
   "q": "Design a 3-touch follow-up sequence for prospects who did not reply to the first email: timing, angle for each touch, and when to stop.",
   "deliverable": "a follow-up playbook with draft copy"
  },
  {
   "q": "Give me a pipeline report for this month: who we contacted, reply rate, positive replies, and which segments are responding best.",
   "deliverable": "a pipeline report with segment breakdown"
  },
  {
   "q": "We are up against a competitor in this deal. Build a one-page battlecard: their pricing, their strengths, where we win, and three questions to ask.",
   "deliverable": "a one-page competitive battlecard"
  }
 ],
 "faq": [
  {
   "q": "What is an AI SDR?",
   "a": "An AI SDR is an AI sales agent that builds lead lists from your ideal customer profile, researches each prospect, writes personal outreach and follows up on schedule."
  },
  {
   "q": "Is an AI SDR the same as an AI sales agent?",
   "a": "Mostly. An AI sales agent is the broader term; an AI SDR focuses on the top of the funnel: finding the right people, starting the conversation and booking the meeting."
  },
  {
   "q": "Will they send from my company email?",
   "a": "Not for cold outreach. Cold email goes from dedicated sending domains with warmed-up mailboxes, daily volume caps and automatic handling of bounces and unsubscribes, so your main domain stays safe. For people who already know you, like customers and inbound leads, your AI SDR can use your own connected mailbox within tight daily limits."
  },
  {
   "q": "Where do the leads come from?",
   "a": "Your own lists, your CRM, or a lead database like Apollo if you connect one. Your AI SDR researches each company and only writes to people who fit."
  },
  {
   "q": "What happens when a prospect replies?",
   "a": "Follow-ups stop at once and the reply lands in your AI SDR's inbox for a considered answer. When a call is next, they hand off to you with the thread and research attached."
  },
  {
   "q": "Will the emails feel like spam?",
   "a": "The approach is small batches of researched, individual emails. Volume caps are built in, so your AI SDR can't blast even if asked."
  },
  {
   "q": "Does an AI SDR handle inbound or outbound?",
   "a": "Mostly outbound: they build lists and send researched first emails from dedicated sending domains. When prospects reply, your AI SDR answers in the same thread and hands the interested ones to you. Your AI SDR does not make cold calls."
  },
  {
   "q": "How is an AI SDR agent different from AI SDR tools?",
   "a": "Most AI SDR software sends the sequences you set up. An AI SDR agent does the whole job: they research each account, write each email for that person, follow up on schedule and report what is working."
  },
  {
   "q": "Can I try an AI SDR for free?",
   "a": "Yes. Every new account gets 200 free credits, and no credit card is needed to sign up. Use them to hire your AI SDR and try a first task."
  },
  {
   "q": "What does an AI SDR cost?",
   "a": "__COST_FAQ__"
  },
  {
   "q": "How do I get started?",
   "a": "Click \"Get started\" to sign up and hire your AI SDR in minutes, or use \"Talk to us\" and our team will help you set them up."
  }
 ],
 "ctaBand": {
  "title": "Put your AI SDR to work today",
  "body": "Give them your ideal customer profile and get back a researched lead list with personalized outreach drafts."
 },
 "audience": {
  "title": "Who hires an AI SDR",
  "cards": [
   {
    "badge": "Solo founders",
    "title": "Prospecting without losing a day a week",
    "body": "List building, research and first-touch emails handed off, so selling time goes to the people who replied."
   },
   {
    "badge": "Small businesses",
    "title": "Outbound that keeps running",
    "body": "Researched lists, personal outreach and follow-ups on schedule, even in the weeks the team is busy closing."
   },
   {
    "badge": "Mid-size companies",
    "title": "More first conversations per rep",
    "body": "Give each rep or segment its own AI SDR, with separate lead lists, messages and reports."
   },
   {
    "badge": "Agencies",
    "title": "Outreach across clients",
    "body": "A separate AI SDR agent for each client, each with their own lead lists and messages."
   },
   {
    "badge": "B2B software companies",
    "title": "Outreach to a defined buyer",
    "body": "Give your AI SDR your ideal customer profile. They build the list, research each account and write to the right person."
   },
   {
    "badge": "Consultancies and service firms",
    "title": "A steady flow of new conversations",
    "body": "Partners spend their time on calls with people who replied, not on research and first emails."
   }
  ]
 }
};

export default content;
